import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import defaultTo from 'lodash/defaultTo';
import noop from 'lodash/noop';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import { action, computed, isArrayLike, observable, runInAction, toJS } from 'mobx';
import { pxToRem, scaleSize } from '../../../lib/_util/UnitConvertor';
import KeyCode from '../../../lib/_util/KeyCode';
import { Size } from '../../../lib/_util/enum';
import Icon from '../icon';
import LovView from './LovView';
import Modal from '../modal/Modal';
import DataSet from '../data-set/DataSet';
import Record from '../data-set/Record';
import Spin from '../spin';
import lovStore from '../stores/LovCodeStore';
import autobind from '../_util/autobind';
import { stopEvent } from '../_util/EventManager';
import ObserverSelect, { isSearchTextEmpty, Select, } from '../select/Select';
import Option from '../option/Option';
import { TableQueryBarType } from '../table/enum';
import { CheckedStrategy, DataSetStatus, RecordStatus } from '../data-set/enum';
import { PopupSearchMode, SearchAction, ViewMode } from './enum';
import Button from '../button/Button';
import { ButtonColor, FuncType } from '../button/enum';
import { $l } from '../locale-context';
import { getLovPara } from '../stores/utils';
import isIE from '../_util/isIE';
import { TriggerViewMode } from '../trigger-field/TriggerField';
import mergeProps from '../_util/mergeProps';
let Lov = class Lov extends Select {
    get searchMatcher() {
        const { searchMatcher } = this.observableProps;
        if (isString(searchMatcher)) {
            return searchMatcher;
        }
        const { viewMode } = this.observableProps;
        const { textField } = this;
        if (viewMode === TriggerViewMode.popup) {
            const { options: { queryDataSet } } = this;
            if (queryDataSet) {
                const queryFields = Array.from(queryDataSet.fields.keys());
                if (queryFields.length && !queryFields.includes(textField)) {
                    return queryFields[0];
                }
            }
        }
        return textField;
    }
    get searchable() {
        const { searchable } = this.observableProps;
        if (searchable === false) {
            return searchable;
        }
        const config = this.getConfig();
        if (config) {
            return config.editableFlag === 'Y';
        }
        return true;
    }
    get lovCode() {
        const { field } = this;
        if (field) {
            return field.get('lovCode', this.record);
        }
        return undefined;
    }
    get popup() {
        const { popupSearchMode } = this.props;
        const { viewMode } = this.observableProps;
        if (viewMode === TriggerViewMode.popup && popupSearchMode === PopupSearchMode.single) {
            return this.modal || (this.isSearchFieldInPopup() && !this.searchText) ? false : this.statePopup;
        }
        return this.modal || (!this.isSearchFieldInPopup() && !this.searchText) ? false : this.statePopup;
    }
    /**
     * 点击查询仅存在一条数据时自动选中, Button 模式禁用
     */
    get autoSelectSingle() {
        const { viewMode } = this.observableProps;
        const { mode } = this.props;
        if (viewMode === TriggerViewMode.popup || mode === ViewMode.button) {
            return false;
        }
        if ('autoSelectSingle' in this.props) {
            return this.props.autoSelectSingle;
        }
        const autoSelectSingle = this.getContextConfig('lovAutoSelectSingle');
        if (typeof autoSelectSingle !== 'undefined') {
            return autoSelectSingle;
        }
        return false;
    }
    get options() {
        const { field, lovCode, record } = this;
        if (field) {
            const options = field.getOptions(record);
            if (options) {
                return options;
            }
        }
        if (lovCode) {
            const lovDataSet = lovStore.getLovDataSet(lovCode, field, field && field.get('optionsProps', record), record);
            if (lovDataSet) {
                return lovDataSet;
            }
        }
        return new DataSet(undefined, { getConfig: this.getContextConfig });
    }
    get showSelectedInView() {
        if ('showSelectedInView' in this.props) {
            return this.props.showSelectedInView;
        }
        const lovShowSelectedInView = this.getContextConfig('lovShowSelectedInView');
        if (isFunction(lovShowSelectedInView)) {
            return lovShowSelectedInView(this.props.viewMode);
        }
        return lovShowSelectedInView;
    }
    getSearchFieldProps() {
        const searchFieldProps = super.getSearchFieldProps();
        const { viewMode } = this.observableProps;
        if (viewMode === TriggerViewMode.popup) {
            return {
                multiple: true,
                ...searchFieldProps,
            };
        }
        return searchFieldProps;
    }
    isSearchFieldInPopup() {
        const searchFieldInPopup = super.isSearchFieldInPopup();
        if (searchFieldInPopup === undefined) {
            const { viewMode } = this.observableProps;
            if (viewMode === TriggerViewMode.popup) {
                const { popupSearchMode } = this.props;
                return popupSearchMode !== PopupSearchMode.single;
            }
        }
        return searchFieldInPopup;
    }
    popupEditable() {
        return !super.disabled && !super.readOnly && this.searchable;
    }
    isEditable() {
        const { viewMode } = this.observableProps;
        const { popupSearchMode } = this.props;
        if (viewMode === TriggerViewMode.popup) {
            return popupSearchMode === PopupSearchMode.single && this.popupEditable();
        }
        return super.isEditable();
    }
    handleSearchMatcherChange(searchMatcher) {
        this.observableProps.searchMatcher = searchMatcher;
        this.searchText = undefined;
        const { onSearchMatcherChange = noop } = this.props;
        onSearchMatcherChange(searchMatcher);
    }
    renderSearchFieldPrefix(props) {
        if (props) {
            const { queryDataSet } = props;
            if (queryDataSet) {
                const { fields } = queryDataSet;
                if (fields.size > 0) {
                    const options = [];
                    const { searchMatcher } = this;
                    fields.forEach((field, name) => {
                        options.push(React.createElement(Option, { key: String(name), value: name }, field.get('label')));
                    });
                    const { prefixCls } = this;
                    return (React.createElement(React.Fragment, null,
                        React.createElement(ObserverSelect, { value: searchMatcher, onChange: this.handleSearchMatcherChange, border: false, clearButton: false, className: `${prefixCls}-lov-search-option`, getPopupContainer: this.getPopupWrapper, isFlat: true }, options),
                        React.createElement("div", { className: `${prefixCls}-lov-search-option-divide` })));
                }
            }
        }
    }
    getPopupLovView() {
        const config = this.getConfig();
        this.autoCreate();
        const { options } = this;
        if (config && options) {
            let lovViewProps;
            if (!this.popup)
                delete this.fetched;
            if (this.popup && !this.fetched) {
                runInAction(() => {
                    lovViewProps = this.beforeOpen(options);
                    this.afterOpen(options);
                    this.fetched = true;
                });
            }
            const tableProps = this.getTableProps(lovViewProps && lovViewProps.tableProps);
            const { popupSearchMode } = this.props;
            const mergedTableProps = mergeProps(tableProps, {
                style: {
                    maxHeight: 250,
                },
                pagination: { showSizeChanger: false },
                queryBar: popupSearchMode === PopupSearchMode.single ? TableQueryBarType.none : this.renderSearchField,
                border: false,
                size: Size.small,
            });
            const { onBeforeSelect, viewMode } = this.props;
            return (React.createElement(LovView, Object.assign({}, lovViewProps, { viewMode: viewMode, dataSet: options, config: config, context: this.context, tableProps: mergedTableProps, onSelect: this.handleLovViewSelect, onBeforeSelect: onBeforeSelect, multiple: this.multiple, values: this.getValues(), popupHidden: !this.popup })));
        }
    }
    getPopupContent() {
        const { searchAction } = this.props;
        const { viewMode } = this.observableProps;
        if (viewMode === TriggerViewMode.popup) {
            return this.getPopupLovView();
        }
        if (searchAction === SearchAction.input) {
            return super.getPopupContent();
        }
        return null;
    }
    syncOptionsSelectedAfterValueRemove(values) {
        const { viewMode } = this.props;
        if (viewMode === TriggerViewMode.popup) {
            const { options, valueField, primitive } = this;
            if (options) {
                const { selected } = options;
                values.forEach(value => {
                    const primitiveValue = primitive ? value : value[valueField];
                    const oldSelected = selected.find(r => r.get(valueField) === primitiveValue);
                    if (oldSelected) {
                        options.unSelect(oldSelected);
                    }
                });
            }
        }
    }
    removeValues(values, index) {
        super.removeValues(values, index);
        this.syncOptionsSelectedAfterValueRemove(values);
    }
    removeLastValue() {
        const value = super.removeLastValue();
        if (value) {
            this.syncOptionsSelectedAfterValueRemove([value]);
        }
        return value;
    }
    clear() {
        super.clear();
        const { viewMode } = this.props;
        if (viewMode === TriggerViewMode.popup) {
            const { options } = this;
            if (options) {
                options.unSelectAll();
                options.clearCachedSelected();
            }
        }
    }
    beforeOpen(options) {
        const { multiple, primitive, valueField } = this;
        if (multiple) {
            options.selectionStrategy = this.getProp('showCheckedStrategy') || CheckedStrategy.SHOW_ALL;
        }
        const { viewMode, viewRenderer } = this.props;
        const { selected } = options;
        if (viewMode === TriggerViewMode.modal || viewMode === TriggerViewMode.drawer) {
            options.unSelectAll();
            // TODO：lovEvents deprecated
            const { lovEvents } = this.props;
            if (lovEvents) {
                Object.keys(lovEvents).forEach(event => options.addEventListener(event, lovEvents[event]));
            }
        }
        if (multiple) {
            const needToFetch = new Map();
            options.setCachedSelected(this.getValues().map(value => {
                const primitiveValue = primitive ? value : value[valueField];
                const oldSelected = selected.find(r => r.get(valueField) === primitiveValue);
                if (oldSelected) {
                    oldSelected.isSelected = true;
                    return oldSelected;
                }
                const newSelected = new Record(primitive ? { [valueField]: value } : toJS(value), options, RecordStatus.sync);
                newSelected.isSelected = true;
                newSelected.isCached = true;
                needToFetch.set(primitiveValue, newSelected);
                return newSelected;
            }));
            const { lovCode } = this;
            if (lovCode) {
                const lovQueryCachedSelected = this.getContextConfig('lovQueryCachedSelected');
                if (lovQueryCachedSelected) {
                    const fetchCachedSelected = () => {
                        if (needToFetch.size) {
                            lovQueryCachedSelected(lovCode, needToFetch).then(action((results) => {
                                results.forEach((data) => {
                                    const record = needToFetch.get(data[valueField]);
                                    if (record) {
                                        record.init(data);
                                    }
                                });
                                needToFetch.clear();
                            }));
                        }
                    };
                    if (viewMode === TriggerViewMode.popup) {
                        fetchCachedSelected();
                    }
                    else if (viewMode === TriggerViewMode.drawer && viewRenderer !== undefined) {
                        return {};
                    }
                    else {
                        return {
                            tableProps: {
                                onShowCachedSelectionChange: (visible) => {
                                    if (visible) {
                                        fetchCachedSelected();
                                    }
                                },
                                pagination: {
                                    onChange() {
                                        fetchCachedSelected();
                                    },
                                },
                            },
                        };
                    }
                }
            }
        }
    }
    afterOpen(options, fetchSingle) {
        const { tableProps } = this.props;
        const { modal } = this;
        const { viewMode } = this.observableProps;
        // 模态框模式下， tableProps 支持获取 modal 实例
        if (isFunction(tableProps) && [TriggerViewMode.modal, TriggerViewMode.drawer].includes(viewMode) && modal) {
            const lovViewProps = this.beforeOpen(options);
            const tableProps = this.getTableProps(lovViewProps && lovViewProps.tableProps);
            modal.update({
                children: React.createElement(LovView, Object.assign({}, this.initedModalLovViewProps, { tableProps: tableProps })),
            });
        }
        if (this.autoSelectSingle) {
            if (this.multiple)
                options.releaseCachedSelected();
        }
        else {
            const noCache = defaultTo(this.getProp('noCache'), this.getContextConfig('lovNoCache'));
            if (this.resetOptions(noCache) && fetchSingle !== true && !this.multiple) {
                options.query(1, undefined, true);
            }
            else if (this.multiple) {
                if (this.resetOptions(noCache)) {
                    options.query(1, undefined, true);
                }
                options.releaseCachedSelected();
            }
        }
    }
    getSelectionProps() {
        const { nodeRenderer, selectionProps } = this.props;
        const lovSelectionProps = this.getContextConfig('lovSelectionProps');
        const props = {
            ...lovSelectionProps,
        };
        if (nodeRenderer) {
            props.nodeRenderer = nodeRenderer;
        }
        return {
            ...props,
            ...selectionProps,
        };
    }
    openModal(fetchSingle) {
        this.collapse();
        const { viewMode } = this.observableProps;
        const { onBeforeSelect, viewRenderer } = this.props;
        const drawer = viewMode === TriggerViewMode.drawer;
        if (viewMode === TriggerViewMode.modal || drawer) {
            const config = this.getConfig();
            this.autoCreate();
            const { options } = this;
            if (config && options) {
                const { modal } = this;
                if (modal) {
                    modal.open();
                }
                else {
                    const { width, title } = config;
                    const lovViewProps = this.beforeOpen(options);
                    const modalProps = this.getModalProps();
                    const tableProps = this.getTableProps(lovViewProps && lovViewProps.tableProps);
                    const valueField = this.getProp('valueField');
                    const textField = this.getProp('textField');
                    this.initedModalLovViewProps = {
                        ...lovViewProps,
                        viewMode,
                        dataSet: options,
                        config,
                        context: this.context,
                        tableProps,
                        onSelect: this.handleLovViewSelect,
                        onBeforeSelect,
                        multiple: this.multiple,
                        values: this.getValues(),
                        valueField,
                        textField,
                        viewRenderer,
                        showSelectedInView: this.showSelectedInView,
                        getSelectionProps: this.getSelectionProps,
                    };
                    this.modal = Modal.open(mergeProps({
                        title: title || this.getLabel(),
                        children: (React.createElement(LovView, Object.assign({}, this.initedModalLovViewProps))),
                        onClose: this.handleLovViewClose,
                        destroyOnClose: true,
                        closable: true,
                        autoFocus: false,
                        className: this.getModalClassName(),
                        bodyStyle: {
                            minHeight: isIE() ? pxToRem(Math.min(scaleSize(350), window.innerHeight), true) : 'min(3.5rem, 100vh)',
                        },
                        drawer,
                        drawerBorder: !drawer,
                        style: {
                            width: pxToRem(width),
                        },
                        afterClose: this.handleLovViewAfterClose,
                    }, modalProps) || {});
                    this.afterOpen(options, fetchSingle);
                }
            }
        }
    }
    getModalClassName() {
        const { viewMode } = this.props;
        return classNames({
            [`${this.prefixCls}-lov-selection-wrapper`]: viewMode === TriggerViewMode.modal && this.showSelectedInView,
            [`${this.prefixCls}-lov-custom-drawer`]: viewMode === TriggerViewMode.drawer && this.multiple && this.showSelectedInView,
            [`${this.prefixCls}-lov-modal`]: viewMode === TriggerViewMode.modal,
            [`${this.prefixCls}-lov-modal-drawer`]: viewMode === TriggerViewMode.drawer,
            [`${this.prefixCls}-lov-popup`]: viewMode === TriggerViewMode.popup,
        });
    }
    setText(text) {
        if (text === undefined || text === '') {
            delete this.searching;
        }
        else {
            this.searching = true;
        }
        super.setText(text);
    }
    /**
     * 处理 Lov input 查询参数
     * @param text
     */
    searchRemote(text) {
        const { options, searchMatcher, observableProps: { viewMode } } = this;
        if (isString(searchMatcher) && (viewMode === TriggerViewMode.popup || !isSearchTextEmpty(text))) {
            this.resetOptions(true);
            const searchPara = this.getSearchPara(searchMatcher, text);
            Object.keys(searchPara).forEach(key => {
                const value = searchPara[key];
                options.setQueryParameter(key, value === '' ? undefined : value);
            });
            if (this.isSearchFieldInPopup() || this.props.searchAction === SearchAction.input) {
                options.query(1, undefined, true).then(() => delete this.searching);
            }
        }
    }
    handlePopupHiddenChange(hidden) {
        super.handlePopupHiddenChange(hidden);
        const { viewMode } = this.observableProps;
        if (viewMode === TriggerViewMode.popup && !this.multiple && this.searchText) {
            this.searchText = undefined;
        }
        if (hidden) {
            delete this.fetched;
        }
    }
    handleLovViewClose() {
        this.focus();
    }
    /**
     * 关闭弹窗移除时间监听 后续废弃
     */
    handleLovViewAfterClose() {
        // TODO：lovEvents deprecated
        const { options, props: { lovEvents } } = this;
        if (lovEvents) {
            Object.keys(lovEvents).forEach(event => options.removeEventListener(event, lovEvents[event]));
        }
        this.setPopup(false);
        this.modal = undefined;
        this.focus();
    }
    handleLovViewSelect(records) {
        const { viewMode } = this.observableProps;
        if (isArrayLike(records)) {
            this.setValue(records.map(record => this.processRecordToObject(record)));
        }
        else {
            this.setValue(records && this.processRecordToObject(records) || this.emptyValue);
        }
        if (viewMode === TriggerViewMode.popup && !this.multiple) {
            this.collapse();
        }
    }
    processRecordToObject(record) {
        const config = this.getConfig();
        if (config) {
            const { transformSelectedData } = config;
            if (transformSelectedData) {
                const data = transformSelectedData(record.toData());
                return this.primitive ? this.restrictInput(data[this.valueField]) : data;
            }
        }
        return super.processRecordToObject(record);
    }
    resetOptions(noCache = false) {
        const { field, record, options } = this;
        const { queryDataSet, props: { pageSize } } = options;
        let dirty = noCache;
        if (noCache) {
            options.pageSize = pageSize || 10;
        }
        if (queryDataSet && noCache) {
            const { current } = queryDataSet;
            if (current && current.dirty) {
                dirty = true;
                current.reset();
            }
        }
        if (field) {
            const lovPara = getLovPara(field, record);
            if (!isEqual(lovPara, options.queryParameter)) {
                options.queryParameter = lovPara;
                return true;
            }
            options.first();
            if (!options.length) {
                return true;
            }
        }
        return dirty;
    }
    handleKeyDown(e) {
        if (!this.popup && e.keyCode === KeyCode.DOWN) {
            stopEvent(e);
            this.handleOpenModal();
        }
        if (e.keyCode === KeyCode.ENTER && this.props.searchAction === SearchAction.blur) {
            stopEvent(e);
            this.blur();
        }
        if (!(e.keyCode === KeyCode.ENTER && this.searching && this.popup)) {
            super.handleKeyDown(e);
        }
        if (e.keyCode === KeyCode.ENTER && this.props.popupSearchMode === PopupSearchMode.single) {
            const record = this.options.current;
            if (record) {
                this.handleLovViewSelect(record);
            }
        }
    }
    handleBlur(e) {
        if (this.modal) {
            e.preventDefault();
        }
        if (this.props.popupSearchMode !== PopupSearchMode.single) {
            super.handleBlur(e);
        }
    }
    getWrapperProps() {
        return super.getWrapperProps({
            onDoubleClick: (this.disabled || this.readOnly) ? undefined : this.handleOpenModal,
            // Support ued to distinguish between select and lov
            className: this.getWrapperClassNames(`${this.prefixCls}-lov`),
        });
    }
    getPopupClassName(defaultClassName) {
        const { viewMode } = this.observableProps;
        return classNames(defaultClassName, { [`${this.prefixCls}-lov-popup`]: viewMode === TriggerViewMode.popup });
    }
    syncValueOnBlur(value) {
        const { textField } = this;
        const { mode, searchAction, fetchSingle } = this.props;
        if (mode !== ViewMode.button) {
            let hasRecord = false;
            if (this.getValue()) {
                hasRecord = this.getValue()[textField] === value;
            }
            if (searchAction === SearchAction.blur && value && !hasRecord) {
                const { options } = this;
                options.query(1, undefined, true).then(() => {
                    const { length } = options;
                    if ((length > 1 && !fetchSingle) || length === 1) {
                        const record = options.get(0);
                        if (!this.optionIsSelected(record, this.getValues())) {
                            this.choose(record);
                        }
                    }
                    else if (length && fetchSingle) {
                        this.openModal(fetchSingle);
                    }
                });
            }
            else if (!this.multiple) {
                super.syncValueOnBlur(value);
            }
            else if (this.getProp('required')) {
                const oldValues = this.getValues();
                this.validate(oldValues, false);
            }
        }
    }
    getConfig() {
        const { lovCode } = this;
        if (lovCode) {
            return lovStore.getConfig(lovCode);
        }
    }
    getPlaceholders() {
        const placeholder = super.getPlaceholders();
        if (placeholder.length) {
            return placeholder;
        }
        const config = this.getConfig();
        if (config) {
            const { placeholder: holder } = config;
            const holders = [];
            return holder ? holders.concat(holder) : holders;
        }
        return [];
    }
    getModalProps() {
        const { modalProps } = this.props;
        return { ...this.getContextConfig('lovModalProps'), ...modalProps };
    }
    getTableProps(localTableProps) {
        const { tableProps } = this.props;
        const lovTablePropsConfig = this.getContextConfig('lovTableProps');
        const lovTablePropsConfigData = isFunction(lovTablePropsConfig)
            ? lovTablePropsConfig(this.multiple)
            : lovTablePropsConfig;
        let tablePropsData;
        if (isObject(tableProps)) {
            tablePropsData = tableProps;
        }
        if (isFunction(tableProps)) {
            const { modal } = this;
            const { viewMode } = this.observableProps;
            const lovTableProps = { ...lovTablePropsConfig, ...localTableProps };
            if (viewMode === TriggerViewMode.popup) {
                tablePropsData = tableProps(lovTableProps);
            }
            else if ([TriggerViewMode.modal, TriggerViewMode.drawer].includes(viewMode) && modal) {
                tablePropsData = tableProps(lovTableProps, modal);
            }
        }
        return {
            ...lovTablePropsConfigData,
            ...mergeProps(localTableProps, tablePropsData),
        };
    }
    async selectSingle() {
        const { options } = this;
        this.resetOptions(options.length === 1);
        await options.query(1, undefined, true);
        if (options.length === 1) {
            const values = this.getValues();
            const record = options.get(0);
            if (!this.optionIsSelected(record, values)) {
                this.choose(record);
            }
        }
        else {
            this.openModal();
        }
    }
    handleOpenModal() {
        if (!this.disabled && !this.readOnly) {
            return this.autoSelectSingle ? this.selectSingle() : this.openModal();
        }
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'modalProps',
            'noCache',
            'tableProps',
            'lovEvents',
            'searchAction',
            'fetchSingle',
            'autoSelectSingle',
            'showCheckedStrategy',
            'onBeforeSelect',
            'onSearchMatcherChange',
            'viewRenderer',
            'nodeRenderer',
            'showSelectedInView',
            'selectionProps',
            'popupSearchMode',
        ]);
    }
    getButtonProps() {
        const { className, type } = this.props;
        const { options } = this;
        const props = {
            ...Button.defaultProps,
            ...omit(this.getOtherProps(), ['name']),
            dataSet: options,
            className: classNames(className, `${this.prefixCls}-lov`),
            type,
        };
        if (!this.valid) {
            props.color = ButtonColor.red;
        }
        return props;
    }
    get loading() {
        const { options } = this;
        return options.status === DataSetStatus.loading;
    }
    saveSuffixRef(node) {
        this.suffixRef = node;
    }
    getSuffix() {
        const { viewMode } = this.observableProps;
        const { suffix } = this.props;
        if (viewMode === TriggerViewMode.popup) {
            return super.getSuffix();
        }
        const icon = this.loading && !this.modal ? React.createElement(Spin, { className: `${this.prefixCls}-lov-spin` }) : React.createElement(Icon, { type: "search" });
        return this.wrapperSuffix(suffix || icon, {
            onClick: (this.disabled || this.readOnly || this.loading) ? undefined : this.handleOpenModal,
        });
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.modal) {
            this.modal.close();
        }
    }
    select() {
        const { mode } = this.props;
        if (mode !== ViewMode.button) {
            super.select();
        }
    }
    handleButtonClick(e) {
        const { onClick = noop } = this.props;
        onClick(e);
        if (!e.isDefaultPrevented()) {
            return this.handleOpenModal();
        }
    }
    getTextByValue(value) {
        const { mode } = this.props;
        return mode === ViewMode.button ? this.processRenderer(value) : super.getTextByValue(value);
    }
    renderWrapper() {
        const { mode, children, clearButton } = this.props;
        if (mode === ViewMode.button) {
            const elements = [
                React.createElement(Button, Object.assign({ key: "lov_button" }, this.getButtonProps(), { disabled: this.disabled, onClick: this.handleButtonClick }), children || this.getTextNode() || this.getPlaceholders()[0] || $l('Lov', 'choose')),
            ];
            if (clearButton) {
                elements.push(React.createElement(Button, { key: "lov_clear_button", size: Size.small, funcType: FuncType.flat, icon: "close", onClick: this.handleClearButtonClick }));
            }
            return elements;
        }
        return super.renderWrapper();
    }
};
Lov.displayName = 'Lov';
Lov.defaultProps = {
    ...Select.defaultProps,
    clearButton: true,
    checkValueOnOptionsChange: false,
    dropdownMatchSelectWidth: false,
    searchAction: SearchAction.input,
    fetchSingle: false,
    viewMode: TriggerViewMode.modal,
    popupSearchMode: PopupSearchMode.multiple,
};
__decorate([
    observable
], Lov.prototype, "modal", void 0);
__decorate([
    computed
], Lov.prototype, "searchMatcher", null);
__decorate([
    computed
], Lov.prototype, "searchable", null);
__decorate([
    computed
], Lov.prototype, "lovCode", null);
__decorate([
    computed
], Lov.prototype, "options", null);
__decorate([
    autobind,
    action
], Lov.prototype, "handleSearchMatcherChange", null);
__decorate([
    autobind
], Lov.prototype, "renderSearchFieldPrefix", null);
__decorate([
    autobind
], Lov.prototype, "getPopupContent", null);
__decorate([
    action
], Lov.prototype, "removeValues", null);
__decorate([
    action
], Lov.prototype, "beforeOpen", null);
__decorate([
    action
], Lov.prototype, "afterOpen", null);
__decorate([
    autobind
], Lov.prototype, "getSelectionProps", null);
__decorate([
    action
], Lov.prototype, "openModal", null);
__decorate([
    action
], Lov.prototype, "setText", null);
__decorate([
    action
], Lov.prototype, "searchRemote", null);
__decorate([
    autobind
], Lov.prototype, "handlePopupHiddenChange", null);
__decorate([
    autobind
], Lov.prototype, "handleLovViewClose", null);
__decorate([
    autobind,
    action
], Lov.prototype, "handleLovViewAfterClose", null);
__decorate([
    autobind
], Lov.prototype, "handleLovViewSelect", null);
__decorate([
    autobind
], Lov.prototype, "handleKeyDown", null);
__decorate([
    autobind
], Lov.prototype, "handleBlur", null);
__decorate([
    autobind,
    action
], Lov.prototype, "selectSingle", null);
__decorate([
    autobind
], Lov.prototype, "handleOpenModal", null);
__decorate([
    computed
], Lov.prototype, "loading", null);
__decorate([
    autobind,
    action
], Lov.prototype, "saveSuffixRef", null);
__decorate([
    autobind
], Lov.prototype, "handleButtonClick", null);
Lov = __decorate([
    observer
], Lov);
export default Lov;
